import {Ability, AbilityBuilder} from '@casl/ability'
import * as routes from '../router/routes';

const ability = new Ability();
export default ability;

export function defineAbilitiesFor(user) {
    const {rules, can} = AbilityBuilder.extract();
    for (const key in routes) {
        if (user.role === 'super_user' && ['super_user', 'editor'].includes(routes[key].role)) {
            can('manage', routes[key].name);
        } else if (user.role === 'editor' && routes[key].role === 'editor') {
            can('manage', routes[key].name);
        }
    }
    ability.update(rules);
}



// WEBPACK FOOTER //
// ./src/util/abilities.js